import React, { useEffect, useState } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

function createSeriesItem(name = '', originalName = null) {
    return {
        id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        name,
        originalName
    };
}

function RenameGroupModal({ballSeries, finalizeRenameResult}){

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [seriesItems, setSeriesItems] = useState([]);

    useEffect(() => {
        if (Array.isArray(ballSeries)) {
            setSeriesItems(
                ballSeries.map(item => {
                    const normalizedName = item === null || item === undefined ? '' : String(item);
                    return createSeriesItem(normalizedName, normalizedName);
                })
            );
        } else {
            setSeriesItems([]);
        }
    }, [ballSeries]);

    const handleSeriesChange = (index, value) => {
        setSeriesItems(prevItems => prevItems.map((item, idx) => (idx === index ? { ...item, name: value } : item)));
    };

    const handleSeriesAdd = () => {
        setSeriesItems(prevItems => [...prevItems, createSeriesItem('')]);
    };

    const handleSeriesDelete = (id) => {
        setSeriesItems(prevItems => prevItems.filter(item => item.id !== id));
    };

    const clickResult = (result) => {
        setButtonDisabled(true);
        let value = {};
        if(result){
            value.ballSeries = seriesItems.map(item => item.name);
            value.seriesItems = seriesItems.map(item => ({
                name: item.name,
                originalName: item.originalName
            }));
        }
        
        finalizeRenameResult(result, value);
    };

    return(
        <div className='modal-container' style={{height:"auto", minHeight:"400px", maxWidth:"400px"}}>
            <button className='modal-close-button' onClick={() => clickResult(false)}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Rename Group</div>
            <div className='modal-content'>
                <span>Group Number(s)</span>
                <div style={{width: '100%', maxHeight: '220px', overflowY: 'auto', marginTop: '10px'}}>
                    {seriesItems.length > 0 ? (
                        seriesItems.map((item, index) => (
                            <div key={item.id} style={{display:'flex', flexDirection:'row', gap:'10px', marginBottom:'10px'}}>
                                <input
                                    className='input'
                                    type='text'
                                    value={item.name}
                                    onChange={(event) => handleSeriesChange(index, event.target.value)}
                                    style={{flexGrow: 1}}
                                />
                                <button
                                    type='button'
                                    className='button'
                                    style={{width:'90px', flexShrink: 0}}
                                    onClick={() => handleSeriesDelete(item.id)}
                                >
                                    Remove
                                </button>
                            </div>
                        ))
                    ) : (
                        <div style={{fontStyle: 'italic'}}>No ball series available.</div>
                    )}
                </div>
                <div style={{width:'100%', display:'flex', justifyContent:'flex-start', marginTop:'10px'}}>
                    <button type='button' className='button' style={{width:'120px'}} onClick={handleSeriesAdd}>Add Group</button>
                </div>
            </div>
            
            <div className="modal-footer" >
                <button disabled={buttonDisabled} className="button" style={{width:'100px'}} onClick={() => clickResult(true)}>Edit</button>
            </div>
        </div>
            );
}

export default RenameGroupModal
